
import logoNetpay from '@assets/logos/netpay-logo.png'
import logoNetpaySmall from '@assets/logos/netpay-logo-small.png'
import { ClientConfigInfo, FILTER_TYPES, METADADATA_LOAD, SurveyResponsesTab } from './configCommons'
import { DASHBOARDS, DASHBOARDS_CONFIGS } from '../dashboard/dashboardCommons'
import { commonFilterCriticalMoments } from '../dashboard/dashHelper'
import deafultHelpDefinition from '../help/defaultHelp'
import { omoikaneNetpay } from '../omoikane/omoikaneNetpay'



export const getNetpayFilterCriticalMoments = (filtersData: Record<string, any>, userProfiles: UserProfile[], selectType: String): CriticalMoment[] => {
    const commonFiltersConfg = commonFilterCriticalMoments(filtersData, userProfiles, selectType)
    //console.log('retornando filtros de HA')
    //console.log(commonFiltersConfg)
    
    //console.log("ENVIROMMENT -> "+ process.env.REACT_APP_ENVIRONMENT )

    return [
        ...commonFiltersConfg,
        //getMetricas(),
    ]
};

export const netpayConfigs: ClientConfigInfo = {
    
    vocBackendUrl: 'https://netpay-backend-voc.clientship.com/api/' ,
    lcmBackendUrl: 'https://netpay-backend-core.clientship.com/api/ui/',
    publicUrl: '/voc',
    logoSmall: logoNetpaySmall,
    logo: logoNetpay,
    filtersFromDateSubstract: 1,
    filtersToDateSubstract: 0,
    decimals: undefined,
    supportsInternationalization: false,
    filters: [
        FILTER_TYPES.DATES,
        FILTER_TYPES.GEOS,
        FILTER_TYPES.CRITICAL_MOMENTS,
        FILTER_TYPES.DYNAMIC
    ],
    menuDashboards: [
        DASHBOARDS.DEFAULT, 
        DASHBOARDS.OXXO_METAS
    ],//, DASHBOARDS.OXXO_EXT],
    sentimentCommentsIndicatorName: 'SENTIMENT_COMMENTS',
    getFilterCriticalMoments: getNetpayFilterCriticalMoments,
    //getFilterCriticalMomentDefault: getFilterCriticalMomentDefault,
    dateFromParamName: 'dateFrom',
    dateToParamName: 'dateTo',
    msExcelReportExt: 'xls',
    useFlatGeoLocations: true,
    geosRootId: 29,
    logicalsRootId: 0,
    criticalMomentsRootId: 29,
    criticalMomentFilterType: 'select',
    actionPlans: {
        geoLeafLevel: '',
        useWorstTags: true
    },
    omoikane: omoikaneNetpay,
    useBackDashboards: false,
    metadata: [
        METADADATA_LOAD.GEOS,
        METADADATA_LOAD.CRITICAL_MOMENTS,
        METADADATA_LOAD.DYNAMIC_REPORT_FIELDS
    ],
    useSentimentCategories: true,
    dashboards: {
        ...DASHBOARDS_CONFIGS.netpay,
        default: DASHBOARDS_CONFIGS.netpay[DASHBOARDS.DEFAULT],
    },
    staticDashboards: {},
    useDashboardDynamicPosition: true,
    surveyResponses: {
        url: 'survey-responses',
        type: 'post-context',
        tableColumns: undefined,
        tabs: [SurveyResponsesTab.ANSWERED],
        surveyDetailFields: [
            {
                position: 1,
                label: 'Área comentario',
                getValue: data => {
                    //console.log('custom field área!!!!!!!!!!')
                    //console.log(data)
                    const sentAnalysis = data
                    ?.questionResponses
                    ?.filter((q: any) => q.questionId === 999)
                    ?.map((q: any) => q.categories)
                    ?.flat(1)
                    ?.filter((item: any, index: any, arr: any) => arr.indexOf(item) === index)
                    //console.log(sentAnalysis)
                    return sentAnalysis?.map((sa: any) => sa === 'DEFAULT' ? 'Otros' : sa)?.join(' | ')
                }
            }
        ],
    },
    alerts: {
    },
    help: deafultHelpDefinition,
    pageSize: 100,
    assistantConfig: {
        enable: true,
        buttonText: "💬",
        tenant: "netpay"
    }
}
